import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../App/redux/store';
import Button from '../../../../../../components/Assets/Button';
import TextInput from '../../../../../../components/Forms/TextInput';
import { getAuthState } from '../../../../authSlice';
import { loginThunk } from '../../../../services/authThunks';
import { ReactComponent as CloseRed } from '.././../../../../../images/close-red.svg';
import { loginInitForm, loginSchema } from './constants';
import styles from './loginForm.module.scss';

function LoginForm() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { login } = useAppSelector(getAuthState);

  const formik = useFormik({
    initialValues: loginInitForm,
    validationSchema: loginSchema,
    onSubmit: (values) => {
      dispatch(loginThunk({ ...values, navigate }));
    },
  });

  const { values, touched, errors } = formik;

  return (
    <div className={styles.loginForm}>
      {login.error && (
        <div className={styles.badCredentials}>
          <CloseRed />
          <p>Votre identifiant ou votre mot de passe est incorrect.</p>
        </div>
      )}
      <form className={styles.form} noValidate>
        <TextInput
          name="username"
          label="Nom complet ou email"
          type="email"
          value={values.username}
          handleChange={formik.handleChange}
          error={touched.username && Boolean(errors.username)}
          helperText={touched.username && errors.username ? errors.username : null}
        />
        <TextInput
          name="password"
          label="Mot de passe"
          type="password"
          value={values.password}
          handleChange={formik.handleChange}
          error={touched.password && Boolean(errors.password)}
          helperText={touched.password && errors.password ? errors.password : null}
        />
        <Button
          btnType="submit"
          btnContent="SE CONNECTER"
          primary
          handleClick={formik.handleSubmit}
        />
      </form>
    </div>
  );
}

export default LoginForm;
